import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import { GetUserInfo } from "../../../utils/permissionChecker";
import {
  unassigned_managers,
  RegisterBranch,
} from "../../../services/employeeApi";
import { toast } from "react-toastify";
const AddBranchForm = ({ parentID, onSubmitButton }) => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const currentUser =
    user.employee.first_name + " " + user.employee.father_name;
  const [formerror, setFormError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    location: "",
    phone: "",
    opening_date: "",
    manager_id: "",
    status: 1,
    created_by: currentUser,
    updated_by: currentUser,
  });
  const queryClient = useQueryClient();
  const registrationMutation = useMutation(async (data) => {
    await RegisterBranch(data);
    queryClient.invalidateQueries("branch");
  });
  const manager_query = useQuery(["manager"], () => unassigned_managers());
  if (manager_query.isLoading) {
    return <div>Loading...</div>;
  }
  if (manager_query.isError) {
    return <div>Error: {manager_query.error.message}</div>;
  }
  const managerData = manager_query.data;
  const handleRegistration = async (Data) => {
    try {
      setIsSubmitting(true);
      console.log(Data);
      await registrationMutation.mutateAsync(Data);
      toast.success("Branch is registerd successfully", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      handleCloseModal();
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const requiredFields = ["name", "phone", "location"];
    const isEmptyField = requiredFields.some((field) => !formData[field]);
    if (isEmptyField) {
      setFormError(true);
      return;
    }
    const payload = { ...formData };
    if (!payload.manager_id) {
      delete payload.manager_id;
    }
    handleRegistration(payload);
  };

  const handleCloseModal = () => {
    onSubmitButton();
  };

  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        {formerror ? (
          <Alert variant="danger">
            <p>Please tray again all fields are required.</p>{" "}
          </Alert>
        ) : (
          ""
        )}
        <Form.Group>
          <Form.Label className="text-secondary">Branch name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter branch name"
            value={formData.name}
            onChange={(e) => handleInputChange(e, "name")}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label className="text-secondary">Branch location</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter branch location"
            value={formData.location}
            onChange={(e) => handleInputChange(e, "location")}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label className="text-secondary">Branch phone</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter branch phone"
            value={formData.phone}
            onChange={(e) => handleInputChange(e, "phone")}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label className="text-secondary">
            Branch opening date
          </Form.Label>
          <Form.Control
            type="date"
            placeholder="Enter branch opening date"
            value={formData.opening_date}
            onChange={(e) => handleInputChange(e, "opening_date")}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label
            htmlFor="inputReason"
            className="font-weight-bold text-muted"
          >
            {t("branch_manager")}
          </Form.Label>
          <select
            id="inputReason"
            className="form-select form-control choicesjs"
            value={formData.manager_id}
            onChange={(e) => handleInputChange(e, "manager_id")}
          >
            <option value="" hidden disabled>
              Select Manager
            </option>
            {managerData &&
              managerData.map((data) => (
                <option key={data.id} value={data.id}>
                  {data.first_name} {data.father_name}
                </option>
              ))}
          </select>
        </Form.Group>
        <div className="d-flex mt-1">
          <div className="mb-1">
            <Button className="btn btn-secondary" onClick={handleCloseModal}>
              {t("cancel")}
            </Button>
          </div>
          <div className="col-md-6 mb-1">
            <Button
              className="btn btn-info"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="visually-hidden">Sending...</span>
                </span>
              ) : (
                t("register")
              )}
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
};

export default AddBranchForm;
